import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Seo } from '@/components/Seo'
import { Section } from '@/components/Page'
import { useI18n } from '@/i18n'

export default function NotFound() {
  const { t } = useI18n()
  return (
    <>
      <Seo title={t('notFound.title')} noIndex />
      <Section rhythm="hero">
        {/* Section wraps its children in a Container, so the centring goes on
            a wrapper INSIDE it — a class on the Section itself only lays out
            the Container, and the body copy would sit at the left edge. */}
        <div data-upbo-src="src/pages/NotFound.tsx:16" className="flex flex-col items-center text-center">
          <p data-upbo-src="src/pages/NotFound.tsx:17" className="font-display text-8xl font-semibold text-primary/30 tabular-nums">404</p>
          <h1 data-upbo-src="src/pages/NotFound.tsx:18" className="mt-6 text-4xl font-semibold tracking-tight">{t('notFound.title')}</h1>
          <p data-upbo-src="src/pages/NotFound.tsx:19" className="mt-4 max-w-md text-muted-foreground">{t('notFound.body')}</p>
          <Button asChild className="mt-8">
            <Link to="/">{t('notFound.home')}</Link>
          </Button>
        </div>
      </Section>
    </>
  )
}